import {useEffect} from "react";

const AgentRequest = () => {

  const handleParams = (params) => {
    localStorage.setItem("lastClicked", "agent_request");
  };

  useEffect(() => {
    const url = window.location.search;
    let params = new URLSearchParams(url);

    handleParams(params);

    const checkLocalStorage = () => {
      return (
        localStorage.getItem('lastClicked')
      );
    };

    const interval = setInterval(() => {
      if (checkLocalStorage()) {
        clearInterval(interval);

        let isLoggedIn = false;
        if (localStorage.getItem('userInfo') && localStorage.getItem('expiration') && localStorage.getItem('token')) {
          isLoggedIn = true;
        }

        if (isLoggedIn) {
          window.location.href = "/";
        } else {
          window.location.href = "/login";
        }
      }
    }, 100);

    return () => clearInterval(interval);

  }, []);

};

export default AgentRequest;